import { faTv, faUniversity } from '@fortawesome/free-solid-svg-icons';

export const ELOQUENT = window.Eloquent;

export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const SITE_URL_HTTP = process.env.REACT_APP_SITE_URL_HTTP;
export const API_URL = process.env.REACT_APP_API_URL;
export const GA_KEY = process.env.REACT_APP_GA_KEY;
export const FBP_KEY = process.env.REACT_APP_FBP_KEY;
export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
export const HOTJAR_SV = process.env.REACT_APP_HOTJAR_SV;

export const STORAGEKEY_LOGIN_TOKEN = 'login-token';
export const STORAGEKEY_CAMPAIGN_EXTERNAL_SUPPORT_IDS = 'campaign-external-support-ids';
export const STORAGEKEY_SHOW_EMAIL_VERIFY = 'email-verify';
export const STORAGEKEY_IS_PWA = 'is-pwa';
export const STORAGEKEY_SHOW_PWA_NOTIFICATION = 'show-pwa-notif';

export const APPID_GOOGLE = '162735683957-j5gb3mqs494sfmbf3b7lbjn4v6e41eis.apps.googleusercontent.com';
export const APPID_FACEBOOK = '368641460353998';
export const FACEBOOK_GRAPH_API = 'https://graph.facebook.com/v3.3/';
export const FACEBOOK_GRAPH_TOKEN = 'EAAFPRwdLO84BALRRjdN502GPU2c7vTDZA7DDboyn8JW4Bs3TY5DY2Ibif41jDIrj0YrH8NpyzpY6xB874eZBSJEDxKZAenVLUyDzMXQ9qUQq4Ut0dRbUMZBZALYugiHL51KNADZBFWXlEhLZA7Jy7i0PAqFn13XUTf8lJMm8voA1qfmqOmqRa498QpyEeK6ZBZBGrlOekaPwCnZCJOTw1VuyGf';

export const CLOUDIMAGE_TOKEN = 'aivaujalen';
export const CLOUDIMAGE_URL = `https://${CLOUDIMAGE_TOKEN}.cloudimg.io/`;

export const FACTIO_EMAIL = 'contact@factio.org';
export const FACTIO_TEL = '+33 6 67 58 46 13';

export const ROUTE_PATHS = {
    DEFAULT: '/',

    LANDING: '/',
    LANDING_ORG: '/associations',

    NEWSFEED: '/accueil',
    PROFILE: (id = ':id') => `/profil/${id}`,
    LOGIN: '/login',
    PASSWORD_RESET: '/password/reset',
    CONFIRM_EMAIL: '/email/verify/',
    FACTIOS: '/communautes',
    FACTIOS_MY: '/mes-communautes',
    FACTIO: (id = ':id', name = '') => `/communaute/${id}/${name}`,
    FACTIO_CREATE: '/communaute-creer',
    FACTIO_EDIT: (id = ':id') => `/communaute-editer/${id}`,
    CAMPAIGNS: '/campagnes',
    CAMPAIGNS_MY: '/mes-campagnes',
    CAMPAIGN: (id = ':id', name = '') => `/campagne/${id}/${name}`,
    CAMPAIGN_CREATE: (id = ':id') => `/campagne-creer/${id}`,
    CAMPAIGN_EDIT: (id = ':id') => `/campagne-editer/${id}`,
    CAMPAIGN_EVENTS: (id = ':id') => `/campagne/${id}/evenements`,
    CAMPAIGN_EVENT_CREATE: (id = ':id') => `/evenement-cree/${id}`,
    CAMPAIGN_EVENT_EDIT: (id = ':id') => `/evenement-editer/${id}`,
    GM: (id = ':id', name = '') => `/grande-mobilisation/${id}/${name}`,
    MY_REPS: '/mes-elus',
    DASHBOARD_REP_CAMPAIGNS: '/tableau-de-bord-rep/campagnes',
    DASHBOARD_REP_CAMPAIGNS_SUPPORT: (id = ':id') => `/tableau-de-bord-rep/campagnes/${id}`,
    DASHBOARD_REP_SURVEYS: '/tableau-de-bord-rep/sondages',
    DASHBOARD_ORG_SUPPORT: '/tableau-de-bord-org/mobilisation-citoyenne',
    DASHBOARD_ORG_ALERT: '/tableau-de-bord-org/interpellation-des-elus',
    NOTIFICATIONS: '/notifications',
    SETTINGS: '/reglages',
    FAQ: '/faq',
    ONBOARDING: '/inscription',
    ONBOARDING_CITIZEN: '/inscription/citoyen',
    ONBOARDING_ORGANIZATION: '/inscription/association-ou-mouvement',
    ONBOARDING_REP: '/inscription/parlementaire',
    ONBOARDING_AFTER: '/inscription/derniere-etape',
    TERMS_AND_CONDITIONS: '/conditions-generales-et-protection-des-donnees.pdf',
    PRIVACY: '/protection-des-donnees.pdf',
    ADMIN: '/admin',
    ADMIN_RPS: '/admin/rps',
    ADMIN_GM_MANAGER: (id = ':id') => `/admin/campagne-gm-manager/${id}`,

    CAMPAIGN_IFRAME: (id = ':id') => `/c/${id}`
};
export const AUTHED_ROUTE_REDIRECT = ROUTE_PATHS.LOGIN;
export const UNAUTHED_ROUTE_REDIRECT = ROUTE_PATHS.NEWSFEED;
export const ROUTE_PATHS_NAV_NORENDER = [
    ROUTE_PATHS.LANDING,
    ROUTE_PATHS.LANDING_ORG,
    ROUTE_PATHS.ONBOARDING,
    ROUTE_PATHS.ONBOARDING_CITIZEN,
    ROUTE_PATHS.ONBOARDING_ORGANIZATION,
    ROUTE_PATHS.ONBOARDING_REP,
    ROUTE_PATHS.LOGIN,
    ROUTE_PATHS.PASSWORD_RESET,
    ROUTE_PATHS.CONFIRM_EMAIL
];

export const ALERT_NOTIFIER_DEFAULT_TIMEOUT = 8000;

export const EMOJI_SET = 'emojione';
export const EMOJI_RENDER_OPTIONS = {
    protocol: 'https',
    baseUrl: '//cdnjs.cloudflare.com/ajax/libs/emojione/2.2.7/assets/png/',
    size: '',
    ext: 'png',
    emojione: true,
    className: 'emoji'
};

export const USER_TYPES = {
    DEFAULT: 1,
    ADMIN: 4,

    // Reps
    DEPUTE: 2,
    SENATEUR: 3,
    CANDIDATE: 5
};

export const REP_REQUEST_STATUS = {
    PENDING: 0,
    ACCEPTED: 1,
    DECLINED: 2
};

export const REP_REQUEST_CONFIG = [
    {
        id: 1,
        icon: faUniversity,
        selection: 'Proposer ou soutenir une loi, un amendement',
        response: 'Proposer ou soutenir une loi'
    }, {
        id: 2,
        icon: faUniversity,
        selection: 'Envoyer une question écrite au gouvernement',
        response: 'Interpeller le gouvernement'
    }, {
        id: 3,
        icon: faTv,
        selection: 'Communiquer médiatiquement (interview, tribune…)',
        response: 'Communiquer dans les médias'
    }, {
        id: 4,
        icon: faTv,
        selection: 'Faire un post sur les réseaux sociaux (Twitter, Facebook)',
        response: 'Poster sur les réseaux sociaux'
    }, {
        id: 5,
        icon: null,
        selection: 'Convaincre un collège, des parlementaires',
        response: 'Convaincre d’autres élus'
    }, {
        id: 6,
        icon: null,
        selection: 'Recevoir l’association',
        response: 'Recevoir l’association'
    }, {
        id: 7,
        icon: null,
        selection: 'Insérer le sujet dans mon programme',
        response: 'Insérer le sujet dans mon programme'
    }
];

export const FACTIO_STRUCTURE_TYPES = [
    {
        id: 0,
        value: 'Sélection'
    }, {
        id: 1,
        value: 'Association / ONG'
    }, {
        id: 2,
        value: 'Mouvement citoyen',
    }, {
        id: 3,
        value: 'Groupe politique'
    }
];

export const CLOUDIMAGE_FILTERS = {
    CAMPAIGN_IMAGE: 'c000000.fbgblur10.fbgopacity50'
};

export const MAX_POST_MESSAGE_LENGTH = 300;
export const MAX_FACTIO_NAME_LENGTH = 45;
export const MAX_CAMPAIGN_NAME_LENGTH = 59;
export const MAX_EVENT_NAME_LENGTH = 100;
export const MIN_METATAG_IMAGE_SIZE = 300;

export const FACTIO_MAX_CATEGORIES = 3;
export const CAMPAIGN_MAX_PRIORITY_REPS = 4;
export const CAMPAIGN_MAX_CATEGORIES = 3;
export const CAMPAIGN_MAX_MEDIA = 10;
export const CAMPAIGN_ISNEW_DAYS_THRESHOLD = 10;
export const CAMPAIGN_REMAINING_DAYS_THRESHOLD = 7;
export const CAMPAIGN_SUPPORTS_MIN_AMOUNT = 100;
export const CAMPAIGN_SUPPORTS_ROUND_AMOUNT = 100;
export const CAMPAIGN_REPS_MIN_AMOUNT = 1000;
export const CAMPAIGN_REPS_ROUND_AMOUNT = 1000;
export const CAMPAIGN_DURATION_TYPES = [
    {
        id: 0,
        name: 'Sélection',
        days: 0
    }, {
        id: 1,
        name: '1 Mois',
        days: 30
    }, {
        id: 2,
        name: '3 Mois',
        days: 90
    }, {
        id: 3,
        name: '6 Mois',
        days: 180
    }
];
export const CAMPAIGNS_HEADER_DATA = {
    TITLE: 'Soutenir une campagne',
    SUBTITLE: 'Soutenez les campagnes de votre choix, alertez vos élus et faites gagner vos idées !'
};
export const FACTIOS_HEADER_DATA = {
    TITLE: 'Suivre une communauté',
    SUBTITLE: 'Suivez les campagnes et l’actualité des associations et des mouvements citoyens qui vous intéressent.'
};

export const GM_SIDES = {
    PRO: 'PRO',
    CONTRA: 'CONTRA'
};

export const MODULE_TYPES = {
    FACTIO: 'App\\Factio',
    CAMPAIGN: 'App\\Campaign',
    POST: 'App\\Post',
    COMMENT: 'App\\Comment',
    EVENT: 'App\\Event'
};

export const REP_CARD_TYPES = {
    HEADER: {
        A: 'A',
        B: 'B'
    },
    FOOTER: {
        REQUESTABLE: 'REQUESTABLE',
        RESPONDANCE: 'RESPONDANCE',
        PROFILE: 'PROFILE',
        GM: 'GM'
    }
};

export const SHARE_TYPES = {
    SOCIAL: 'social',
    FRIENDS: 'friends'
};

export const SHARE_SUB_TYPES = {
    FACEBOOK: 1,
    TWITTER: 2,
    WHATSAPP: 3,
    MESSENGER: 4,
    EMAIL: 5
};

export const SHARE_SUB_TYPE_GROUP = {
    SOCIAL: [
        SHARE_SUB_TYPES.FACEBOOK,
        SHARE_SUB_TYPES.TWITTER
    ],
    FRIENDS: [
        SHARE_SUB_TYPES.WHATSAPP,
        SHARE_SUB_TYPES.MESSENGER,
        SHARE_SUB_TYPES.EMAIL
    ]
};

// Eloquent.Post.getAllPosts orderBy parameters
export const POST_GETALL_ORDERS = {
    POPULAR: {
        orderBy: 'popular'
    },
    RECENT: {
        orderBy: 'recent'
    }
};
export const POST_APP_KEYS = {
    FACTIO: 'factio_id',
    CAMPAIGN: 'campaign_id'
};
export const POST_ATTACHMENT_ACCEPT = 'image/*, video/mp4, video/x-m4v, video/mov, video/webm';
export const POST_ATTACHMENT_VIDEO_EXTENSIONS = ['.mp4', '.m4v', '.mov', '.webm'];

export const DEFAULT_SURVEY_ANSWERS = [
    {
        id: 1,
        value: 'Oui vraiment'
    }, {
        id: 2,
        value: 'Plutôt oui'
    }, {
        id: 3,
        value: 'Pas d\'avis'
    }, {
        id: 4,
        value: 'Plutôt non'
    }, {
        id: 5,
        value: 'Non pas du tout'
    }, {

    }
];

export const REP_POSITIONS_TYPES = {
    PRO: 1,
    PRO_PRIORI: 2,
    UNDEFINED: 3,
    CONTRA_PRIORI: 4,
    CONTRA: 5,
    ABSTENTION: 6
};

export const REP_POSITIONS = [
    {
        id: REP_POSITIONS_TYPES.PRO,
        name: 'Pour',
        text: 'a voté pour',
        notification: 'a voté pour',
        info: 'Position basée sur son vote officiel',
        icon: require('assets/icons/vote-yes.svg')
    }, {
        id: REP_POSITIONS_TYPES.PRO_PRIORI,
        name: 'A priori pour',
        text: 'a voté pour',
        notification: 'est à priori pour',
        info: 'Position basée sur ses prises de paroles publiques et médiatiques, ou la position officielle de son parti',
        icon: require('assets/icons/vote-yes.svg')
    }, {
        id: REP_POSITIONS_TYPES.UNDEFINED,
        name: 'Incertaine',
        text: 's\'est abstenu(e)',
        notification: 'est incertain(e) concernant',
        info: 'Position basée sur ses prises de paroles publiques et médiatiques, ou la position officielle de son parti',
        icon: require('assets/icons/vote-undefined.svg')
    }, {
        id: REP_POSITIONS_TYPES.ABSTENTION,
        name: 'Abstention',
        text: 's\'est abstenu(e)',
        notification: 's\'est abstenu(e) sur',
        info: 'Position basée sur ses prises de paroles publiques et médiatiques, la position de son parti, ou son vote officiel.',
        icon: require('assets/icons/vote-undefined.svg')
    }, {
        id: REP_POSITIONS_TYPES.CONTRA_PRIORI,
        name: 'A priori contre',
        text: 'a voté contre',
        notification: 'est à priori contre',
        info: 'Position basée sur ses prises de paroles publiques et médiatiques, ou la position officielle de son parti',
        icon: require('assets/icons/vote-no.svg')
    }, {
        id: REP_POSITIONS_TYPES.CONTRA,
        name: 'Contre',
        text: 'a voté contre',
        notification: 'a vote contre',
        info: 'Position basée sur son vote officiel',
        icon: require('assets/icons/vote-no.svg')
    }
];

export const LOCATIONS = [
    {
        id: 1,
        name: 'Auvergne-Rhône-Alpes'
    }, {
        id: 2,
        name: 'Hauts-de-France'
    }, {
        id: 3,
        name: 'Provence-Alpes-Côte d’Azur'
    }, {
        id: 4,
        name: 'Grand Est'
    }, {
        id: 5,
        name: 'Occitanie'
    }, {
        id: 6,
        name: 'Normandie'
    }, {
        id: 7,
        name: 'Centre-Val de Loire'
    }, {
        id: 8,
        name: 'Bourgogne-Franche-Comté'
    }, {
        id: 9,
        name: 'Bretagne'
    }, {
        id: 10,
        name: 'Corse'
    }, {
        id: 11,
        name: 'Pays de la Loire'
    }, {
        id: 12,
        name: 'île-de-France'
    }, {
        id: 13,
        name: 'Guadeloupe'
    }, {
        id: 14,
        name: 'Martinique'
    }, {
        id: 15,
        name: 'Guyane'
    }, {
        id: 16,
        name: 'La Réunion'
    }, {
        id: 17,
        name: 'Mayotte'
    }
];

export const HOURS = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];

export const VALID_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
